module.exports = __webpack_public_path__ + "media/application/images/svgs/thumbs-up-2e2abefc498f6c5124d5f4175db323e6.svg";